import { Controller } from "@hotwired/stimulus"

// działa na zasadzie połączenia data-tab-name z tabsTargets (lub id z odpowiadającego panelsTargets),
// w przeciwnym razie łączy po indeksie — kompatybilność wsteczna z innymi widokami
// zapisuje w URL aktualny tab, by odświeżenie wracało na odpowiedni tab
export default class extends Controller {
  static values = { visibleClass: String, hiddenClass: String }
  static targets = ["tabs", "panels"]

  connect() {
    const urlParams = new URLSearchParams(window.location.search)
    const tabParam = urlParams.get("tab")

    if (tabParam) {
      this.activateTabByName(tabParam, false)
    } else {
      this.activateTabByIndex(0, false)
    }
  }

  toggleTab(event) {
    const tabName = this.getTabName(event.target)
    this.activateTabByName(tabName)
  }

  activateTabByName(tabName, updateHistory = true) {
    let targetTabIndex = -1
    let targetPanel = null

    this.tabsTargets.forEach((tab, i) => {
      const elementTabName = this.getTabName(tab)
      if (elementTabName === tabName) {
        targetTabIndex = i
      }
    })

    if (targetTabIndex >= 0) {
      targetPanel = this.panelsTargets.find(panel =>
        panel.dataset.tabName === tabName || panel.id === tabName
      )
      if (!targetPanel && targetTabIndex < this.panelsTargets.length) {
        targetPanel = this.panelsTargets[targetTabIndex]
      }

      if (targetPanel) {
        this.updateTabsAndPanels(targetTabIndex, targetPanel)
        if (updateHistory) {
          this.updateUrlHistory(tabName)
        }
      }
    }
  }

  activateTabByIndex(activeIndex, updateHistory = true) {
    if (activeIndex >= 0 && activeIndex < this.tabsTargets.length && activeIndex < this.panelsTargets.length) {
      const targetPanel = this.panelsTargets[activeIndex]
      this.updateTabsAndPanels(activeIndex, targetPanel)
      if (updateHistory) {
        const tabName = this.getTabName(this.tabsTargets[activeIndex])
        this.updateUrlHistory(tabName)
      }
    }
  }

  updateTabsAndPanels(activeIndex, activePanel) {
    this.tabsTargets.forEach((tab, index) => {
      tab.className = (index === activeIndex) ? this.visibleClassValue : this.hiddenClassValue
    })
    this.panelsTargets.forEach((panel) => {
      if (panel === activePanel) {
        panel.classList.remove("hidden")
      } else {
        panel.classList.add("hidden")
      }
    })
  }

  getTabName(tabElement) {
    if (tabElement.dataset.tabName) {
      return tabElement.dataset.tabName
    }

    const tabIndex = this.tabsTargets.indexOf(tabElement)
    const correspondingPanel = this.panelsTargets[tabIndex]

    if (correspondingPanel && correspondingPanel.id) {
      return correspondingPanel.id
    }

    return `tab-${tabIndex}`
  }

  updateUrlHistory(tabName) {
    const url = new URL(window.location)
    url.searchParams.set("tab", tabName)
    window.history.replaceState({}, "", url.toString())
  }
}
